import { EMPTY_OBJECT } from '../../../constants/common'
import { Widget } from '../Widget'

import { ProfileFinishedWidgetContent } from './ProfileFinishedWidgetContent'

import * as styles from './ProfileFinishedWidget.module.css'

function ProfileFinishedWidget({
  contentContainerProps = {
    className: styles.content,
    skeletonProps: { className: styles.skeleton },
  },
  contentProps = EMPTY_OBJECT,
  isSkeleton,
  title,
  widgetProps = EMPTY_OBJECT,
}) {
  const headerProps = {
    ...widgetProps.headerProps,
    contentProps: {
      ...widgetProps.headerProps?.contentProps,
      actionsProps: {
        ...widgetProps.headerProps?.contentProps?.actionsProps,
        EditButton: null,
      },
    },
  }

  return (
    <Widget
      {...widgetProps}
      contentContainerProps={contentContainerProps}
      headerProps={headerProps}
      isSkeleton={isSkeleton}
      title={title}
    >
      <ProfileFinishedWidgetContent {...contentProps} />
    </Widget>
  )
}

export default ProfileFinishedWidget
